import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import Button from '@components/Button';
import Illustration from '@components/Illustration';
import SupportLink from '@components/SupportLink';
import LoginLayout from '@layouts/LoginLayout';

import Restrict from './restrict.svg';

import style from './Error.scss';

const cn = bemCssModules(style, 'Error');
const ti = getTestId('image');

export const Error: CustomFC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const image = useMemo(
    () => (
      <Illustration
        images={[<Restrict />, '/img/space_suit_user_blocked.png']}
        data-testid={ti()}
      />
    ),
    []
  );

  const onClick = () => navigate(CONST.nav.loginEmail);

  return (
    <LoginLayout image={image} backButton={false}>
      <h1 className={cn('heading')}>{t('error.heading')}</h1>
      <p className={cn('description')}>{t('error.description')}</p>
      <SupportLink href="mailto:info@mercuryo.io" />
      <Button className={cn('button')} onClick={onClick}>
        {t(`public.account_blocked_button`)}
      </Button>
    </LoginLayout>
  );
};

export default Error;
